import FatigueInformation from './FatigueInformation';
export default FatigueInformation;